import { useState } from 'react';
import { Link } from '#components/atoms/link/Link.tsx';
import { CopyIDMenuItem } from '#components/patterns/menus/meatball-menu/CopyIDMenuItem.tsx';
import { MeatballMenu, MenuItem } from '#components/patterns/menus/meatball-menu/index.ts';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { DeleteAPIKeyDialog } from '../../delete/DeleteAPIKeyDialog.tsx';

type Props = {
  value: string;
};

export function APIKeysActionMenu({ value: id }: Props) {
  const [apiKeyBeingDeletedId, setAPIKeyBeingDeletedId] = useState<string | null>(null);
  const location = useAppLocation();

  return (
    <>
      <MeatballMenu>
        <CopyIDMenuItem id={id} />
        <MenuItem render={<Link to={id} state={{ from: location }} />}>Edit</MenuItem>
        <MenuItem
          onClick={() => {
            setAPIKeyBeingDeletedId(id);
          }}
        >
          Revoke
        </MenuItem>
      </MeatballMenu>
      {apiKeyBeingDeletedId ?
        <DeleteAPIKeyDialog
          apiKeyID={apiKeyBeingDeletedId}
          onDelete={() => {
            setAPIKeyBeingDeletedId(null);
          }}
          onCancel={() => {
            setAPIKeyBeingDeletedId(null);
          }}
        />
      : null}
    </>
  );
}
